var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.protocol.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }